import { NativeModules } from 'react-native';

const { RNZoomVideoSdkPhoneSupportCountryInfo } = NativeModules;

/**
 * Support country information interface.
 */
export type ZoomVideoSdkPhoneSupportCountryInfoType = {
  /**
   * Get the country code.
   */
  getCountryCode: () => Promise<string>;

  /**
   * Get the country ID.
   */
  getCountryID: () => Promise<string>;

  /**
   * Get the country name.
   */
  getCountryName: () => Promise<string>;
};

export class ZoomVideoSdkPhoneSupportCountryInfo
  implements ZoomVideoSdkPhoneSupportCountryInfoType
{
  private static instance: ZoomVideoSdkPhoneSupportCountryInfo;

  constructor() {}

  static getInstance() {
    if (!this.instance) {
      this.instance = new this();
    }
    return this.instance;
  }

  async getCountryCode() {
    return await RNZoomVideoSdkPhoneSupportCountryInfo.getCountryCode();
  }

  async getCountryID() {
    return await RNZoomVideoSdkPhoneSupportCountryInfo.getCountryID();
  }

  async getCountryName() {
    return await RNZoomVideoSdkPhoneSupportCountryInfo.getCountryName();
  }
}
